// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__FEwuP","app":"App_app__dJCEp","background_image":"App_background_image__sS6rX"};